import { DynamicQuestionFieldTypes } from './constants'
import { DynamicQuestionsMapping } from './types'

export const QuestionMapping: DynamicQuestionsMapping = {
  part1: {
    qComplyWithAmlRegulations: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qMoneyLaunderingAmlProcedures: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
  },
  part2: {
    qPeriodicAmlAssessment: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qIdentifyClientsAndDueDiligence: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
  },
  part3: {
    qSanctionScreening: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qMonitorClientActivity: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
  },
  part4: {
    qIndependentMlro: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qNumberOfFteStuff: {
      type: DynamicQuestionFieldTypes.NUMBER,
    },
  },
  part5: {
    qMeasuresToPreventMarketManipulation: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qKeyRisks: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
  },
  part6: {
    qSegregationOfClientFunds: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qIpCapture: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
  },
  part7: {
    qFacilitateCryptoCurrency: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qFacilitateUnlicensedCryptoTokens: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  part8: {
    qCoinAcceptancePolicy: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qBlockchainMonitoringTool: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
  },
  part8b: {
    qPastRegulatoryActionsOrPenalties: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qAnyExposureToBvnkProhibitedJurisdictions: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
      customLabel: true,
    },
  },
  part9: {
    qNumberOfStrs: {
      type: DynamicQuestionFieldTypes.NUMBER,
    },
    qSupportIco: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qCleanAssetsPurchase: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qRegularTechnicalAuditsAndPenTests: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  part10: {
    qTravelRuleInForce: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuesion: true,
    },
    qProviderForCompliantDataSharing: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
    qContactDetailsForTravelRule: {
      type: DynamicQuestionFieldTypes.EMAIL,
    },
    qComplianceMatterContact: {
      type: DynamicQuestionFieldTypes.CONTACT,
    },
  },
}

export const MappedQuestionCodes = Object.values(QuestionMapping)?.flatMap(Object.keys)
